<template>
  <v-dialog v-model="dialog" :width="confirmStep ? 440 : 360" :fullscreen="isMobile">
    <v-card class="pa-4">
      <template v-if="!confirmStep">
        <v-card-text class="pa-0 text-body-1 font-weight-medium pb-3">
          {{ $t("discount-Code") }}
        </v-card-text>
        <v-text-field
          v-model="code"
          outlined
          dense
          clearable
          autofocus
          height="30"
          :hide-details="!errorMessage"
          :error="!!errorMessage"
          :error-messages="errorMessage"
          :label="$t('discount-Code')"
          :disabled="loading"
          @keyup.enter="onApply"
        />
        <v-container class="pa-0 d-flex justify-end align-center gap-2 mt-6">
          <v-btn color="error" outlined height="32" :disabled="loading" @click="onCancel">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            height="32"
            :loading="loading"
            :disabled="!hasCode"
            @click="onApply"
          >
            {{ $t("apply-discount") }}
          </v-btn>
        </v-container>
      </template>
      <template v-else>
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="56" color="success">mdi-tag-check-outline</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 text-center mt-3 mb-3">
          {{ $t("promo-code-confirm-message") }}
        </v-card-text>
        <v-sheet color="primary lighten-5" rounded class="pa-3 mb-3 d-flex align-center">
          <v-icon color="primary" class="ml-2">mdi-ticket-percent-outline</v-icon>
          <div class="flex-grow-1">
            <div class="text-caption grey--text text--darken-1">{{ $t("discount-Code") }}</div>
            <div class="text-subtitle-1 font-weight-bold primary--text text--darken-2">
              {{ displayPromoCode }}
            </div>
          </div>
        </v-sheet>
        <v-sheet outlined rounded class="pa-3 mb-3">
          <div
            v-if="displayPercentage != null"
            class="d-flex justify-space-between align-center py-1"
          >
            <span class="text-body-2 grey--text text--darken-2">{{ $t("promo-eligible-discount-percent") }}</span>
            <v-chip small color="primary" text-color="white" class="font-weight-bold">
              {{ displayPercentage }}%
            </v-chip>
          </div>
          <div
            v-if="formattedMinPrice"
            class="d-flex justify-space-between align-center py-1"
          >
            <span class="text-body-2 grey--text text--darken-2">{{ $t("promo-min-payment-amount") }}</span>
            <span class="text-body-2 font-weight-medium">{{ formattedMinPrice }}</span>
          </div>
          <div

            v-if="formattedMaxPrice"

            class="d-flex justify-space-between align-center py-1"

          >

            <span class="text-body-2 grey--text text--darken-2">{{ $t("promo-max-payment-amount") }}</span>

            <span class="text-body-2 font-weight-medium">{{ formattedMaxPrice }}</span>

          </div>

        </v-sheet>



        <v-sheet outlined rounded class="pa-3 mb-4">

          <div class="d-flex justify-space-between text-caption grey--text mb-2">

            <span>{{ $t("previous-discounts-reset") }}</span>

            <span class="error--text font-weight-medium">۰</span>

          </div>

          <v-divider class="my-2" />

          <div class="d-flex justify-space-between align-center">

            <span class="text-body-2">{{ $t("discount-amount") }}</span>

            <span class="text-h6 primary--text font-weight-bold">

              {{ formattedDiscountAmount }}

            </span>

          </div>

          <div

            v-if="formattedNewSubtotal"

            class="d-flex justify-space-between text-caption grey--text mt-2"

          >

            <span>{{ $t("payable-after-discount") }}</span>

            <span>{{ formattedNewSubtotal }}</span>

          </div>

        </v-sheet>



        <v-container class="pa-0 d-flex justify-end align-center gap-2">

          <v-btn color="error" outlined height="32" @click="onConfirmCancel">

            {{ $t("cancel") }}

          </v-btn>

          <v-btn color="primary" height="32" @click="onConfirmApply">

            {{ $t("confirm") }}

          </v-btn>

        </v-container>

      </template>

    </v-card>

  </v-dialog>

</template>



<script>

import General from "@/Mixins/general";



export default {

  name: "HeaderDiscountCodeDialog",

  mixins: [General],

  props: {

    value: {

      type: Boolean,

      default: false,

    },

    customerPhone: {

      type: String,

      default: "",

    },

    orderSubtotal: {

      type: [String, Number],

      default: "",

    },

    useWallet: {

      type: Boolean,

      default: false,

    },

    branchName: {

      type: String,

      default: "",

    },

    discount: {

      type: [String, Number],

      default: "",

    },

  },

  data() {

    return {

      code: "",
      loading: false,

      errorMessage: "",

      confirmStep: false,

      pendingPayload: null,

      pendingDiscountAmount: 0,

    };

  },

  computed: {

    dialog: {

      get() {

        return this.value;

      },

      set(val) {

        this.$emit("input", val);

      },

    },

    hasCode() {

      return !!(this.code && String(this.code).trim());

    },


    formattedDiscountAmount() {

      return this.$numberFormat(this.pendingDiscountAmount);

    },


    formattedNewSubtotal() {

      const sub = this.pendingPayload?.order_subtotal;

      if (sub == null || sub === "") {

        return "";

      }

      return this.$numberFormat(parseFloat(String(sub).replace(/,/g, "")) || 0);

    },


    displayPromoCode() {

      const code = this.pendingPayload?.promo_code || this.code;

      return code ? String(code).trim() : "";

    },


    displayPercentage() {

      const pct = this.pendingPayload?.percentage;

      if (pct == null || pct === "") {

        return null;

      }

      const num = parseFloat(String(pct).replace(/,/g, ""));

      return isNaN(num) ? null : num;

    },


    formattedMinPrice() {

      return this.formatPayloadPrice(this.pendingPayload?.min_price);

    },


    formattedMaxPrice() {

      return this.formatPayloadPrice(this.pendingPayload?.max_price);

    },

  },

  watch: {

    value(open) {

      if (open) {

        this.code = "";

        this.errorMessage = "";

        this.confirmStep = false;

        this.pendingPayload = null;

        this.pendingDiscountAmount = 0;

      }

    },

  },

  methods: {

    parseAmount(value) {

      if (value == null || value === "") {

        return 0;

      }

      return parseFloat(String(value).replace(/,/g, "")) || 0;

    },


    formatPayloadPrice(value) {

      if (value == null || value === "") {

        return "";

      }

      return this.$numberFormat(this.parseAmount(value));

    },

    onApply() {

      var app = this;

      if (!app.hasCode || app.loading) {

        return;

      }

      app.loading = true;

      app.errorMessage = "";

      app.$axios

        .post(app.$apipoint + "config/customer-club/afra/check-promo-code", {

          promo_code: String(app.code).trim() || null,

          customer_phone: app.customerPhone || null,

          use_wallet: app.useWallet ?? null,

          branch_name: app.branchName || null,

          discount: app.discount ? String(app.discount) : null,

          order_subtotal:

            app.orderSubtotal != null &&

            app.orderSubtotal !== "" &&

            parseFloat(String(app.orderSubtotal).replace(/,/g, "")) > 0

              ? String(app.orderSubtotal)

              : null,

        })

        .then((response) => {

          const data = response?.data?.message;

          if (data != null) {

            const currentSubtotal = app.parseAmount(app.orderSubtotal);

            const newSubtotal = app.parseAmount(data.order_subtotal);

            const discountAmount = Math.max(0, currentSubtotal - newSubtotal);



            app.pendingPayload = {

              ...data,

              promo_code: data.promo_code || String(app.code).trim(),

              discount: discountAmount,

            };

            app.pendingDiscountAmount = discountAmount;

            app.confirmStep = true;

          }

        })

        .catch((err) => {

          let errorMessage = err.response.data.message.message;

          app.errorMessage = app.$t("discount code is invalid");

          this.serverErrorHandeler(errorMessage);

        })

        .finally(() => {

          app.loading = false;

        });

    },

    onCancel() {

      this.resetDialog();

    },


    onConfirmApply() {

      if (this.pendingPayload) {

        this.$emit("apply", this.pendingPayload);

      }

      this.resetDialog();

    },


    onConfirmCancel() {

      this.resetDialog();

    },
    resetDialog() {

      this.confirmStep = false;

      this.pendingPayload = null;

      this.pendingDiscountAmount = 0;

      this.dialog = false;

    },

  },

};

</script>

